import {
  WorkRefusalContractType,
  WorkRefusalReason,
  WorkRefusalRequestDetailsFromBE,
  WorkRefusalRequestFromBE,
  WorkRefusalRequestStatus,
} from 'api/laborerPortalAPI/workRefusalRequests'

export type WorkRefusalRequest = {
  id: number
  sponsor: {
    name: string
    idNumber: number
  }
  contract: {
    id: number
    startDate: string
    endDate: string
    status: string
    relatableId: number
    relatableSource: WorkRefusalContractType
  }
  status: WorkRefusalRequestStatus
  reason: WorkRefusalReason['id']
  createdAt?: string
  cancelledAt: string | null
  activatedAt: string | null
}

export type WorkRefusalRequestDetails = WorkRefusalRequest & {
  createdAt: string
  labor: {
    name: string
    nameEn: string
    nationality: string
    nationalityEn: string
    iqamaNumber: string
    passportNumber: string
  }
  employer: {
    name: string
    nationality: string
    idNumber: string
    mobileNumber: string
  }
}

export const convertWorkRefusalRequestFromResponse = (request: WorkRefusalRequestFromBE): WorkRefusalRequest => ({
  id: request.id,
  sponsor: {
    name: request.sponsor.name,
    idNumber: request.sponsor.id_number,
  },
  contract: {
    id: request.contract.id,
    startDate: request.contract.start_date,
    endDate: request.contract.end_date,
    status: request.contract.status,
    relatableId: request.contract.relatable_id,
    relatableSource: request.contract.relatable_source,
  },
  status: request.status,
  reason: request.reason,
  createdAt: request.created_at,
  cancelledAt: request.cancelled_at,
  activatedAt: request.activated_at,
})

export const convertWorkRefusalRequestDetailsFromResponse = (
  request: WorkRefusalRequestDetailsFromBE,
): WorkRefusalRequestDetails => ({
  ...convertWorkRefusalRequestFromResponse(request),
  createdAt: request.created_at,
  labor: {
    name: request.labor.name,
    nameEn: request.labor.name_en,
    nationality: request.labor.nationality,
    nationalityEn: request.labor.nationality_en,
    iqamaNumber: request.labor.iqama_number,
    passportNumber: request.labor.passport_number,
  },
  employer: {
    name: request.employer.name,
    nationality: request.employer.nationality,
    idNumber: request.employer.id_number,
    mobileNumber: request.employer.mobile_number,
  },
})
